import React, { useState, useEffect } from 'react';

const ButtonEdit = ({ isOpen, onClose, buttonSettings, onButtonSettingsChange, handleButtonChange }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-base-100 rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-semibold">Configuración del boton</h3>
                    <button
                        onClick={onClose}
                        className="text-base-content hover:text-gray-700"
                    >
                        ✕
                    </button>
                </div>
                <label className="block mb-2 font-medium">Texto del Botón</label>
                <input
                    type="text"
                    value={buttonSettings.text || "Enviar"}
                    onChange={(e) =>
                        onButtonSettingsChange({
                            ...buttonSettings,
                            text: e.target.value,
                        })
                    }
                    placeholder="Ejemplo: Enviar Respuesta"
                    className="w-full p-2 border rounded"
                />

                <div>
                    <label className="block mb-2 font-medium">Color de Fondo</label>
                    <input
                        type="color"
                        value={buttonSettings.backgroundColor || "#2563eb"}
                        onChange={(e) =>
                            onButtonSettingsChange({
                                ...buttonSettings,
                                backgroundColor: e.target.value,
                            })
                        }
                        className="h-10 w-20"
                    />
                </div>
                <div>
                    <label className="block mb-2 font-medium">Color del Texto</label>
                    <input
                        type="color"
                        value={buttonSettings.textColor || "#ffffff"}
                        onChange={(e) =>
                            onButtonSettingsChange({
                                ...buttonSettings,
                                textColor: e.target.value,
                            })
                        }
                        className="h-10 w-20"
                    />
                </div>
                <div>
                    <label className="block mb-2 font-medium">Bordes del Botón</label>
                    <select
                        value={buttonSettings.borderRadius || "0.375rem"}
                        onChange={(e) => handleButtonChange("borderRadius", e.target.value)}
                        className="w-full p-2 border rounded"
                    >
                        <option value="0">Sin Bordes</option>
                        <option value="0.375rem">Pequeño</option>
                        <option value="0.5rem">Mediano</option>
                        <option value="0.75rem">Grande</option>
                    </select>
                </div>
                <div>
                    <label className="block mb-2 font-medium">Tamaño del Botón</label>
                    <select
                        value={buttonSettings.size}
                        onChange={(e) => handleButtonChange("size", e.target.value)}
                        className="w-full p-2 border rounded"
                    >
                        <option value="small">Pequeño</option>
                        <option value="medium">Mediano</option>
                        <option value="large">Grande</option>
                    </select>
                </div>

                <div>
                    <label className="block mb-2 font-medium">Ubicación del Botón</label>
                    <select
                        value={buttonSettings.position}
                        onChange={(e) => handleButtonChange("position", e.target.value)}

                        className="w-full p-2 border rounded"
                    >
                        <option value="left">Izquierda</option>
                        <option value="center">Centro</option>
                        <option value="right">Derecha</option>
                    </select>
                </div>
                <div className="flex justify-end space-x-2 pt-4 border-t">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 rounded text-base-100 hover:bg-gray-300"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={() => {
                            // Validación básica
                            if (buttonSettings.responseType === 'redirect' && !buttonSettings.redirectUrl) {
                                alert('Por favor, ingresa una URL válida');
                                return;
                            }
                            onClose();
                        }}
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                        Guardar Cambios
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ButtonEdit;